import type {
  BlocksDownloadComponent,
  LinksLinkListComponent,
} from '@twisto/api-cms/generated-types'

import { AccessibleDiv, Hidden } from 'homepage/components/atoms'
import {
  LinkList,
  SecondaryDowndloadWidget,
} from 'homepage/components/molecules'

import * as styles from './footer.styles'

type Props = {
  columns?: LinksLinkListComponent[] | undefined
  toggleList: (id: string | number) => void
  activeLists: Array<string | number>
  widget?: BlocksDownloadComponent | undefined
}

export const MobileGroupedColumns = ({
  columns,
  toggleList,
  activeLists,
  widget,
}: Props) => (
  <Hidden as="div" breakpoint="smMdUp" css={styles.columns}>
    {columns?.map((column) => (
      <AccessibleDiv
        key={column.id}
        css={styles.accordion}
        role="button"
        onActivate={() => column.id && toggleList(column.id)}
      >
        <p
          css={[
            styles.accordionName,
            activeLists.includes(column.id ?? -1) && styles.open,
          ]}
        >
          {column.name}
        </p>
        {activeLists.includes(column.id ?? -1) && (
          <LinkList links={column.links} listStyles={styles.accordionLinks} />
        )}
      </AccessibleDiv>
    ))}
    <SecondaryDowndloadWidget styles={styles.widget} {...widget} />
  </Hidden>
)
